import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
// import { HOURLY_TIME_PERIOD } from '../../config/constants/analytics';
import SectionCard from './components/SectionCard';
import ChartTabs from './components/ChartTabs';
import CancelledOrderBarChart from './BarChart/CancelledOrderBarChart';
import CompletedOrderBarChart from './BarChart/CompletedOrderBarChart';
import CancelledOrderHeatmapChart from './Heatmap/CancelledOrderHeatmapChart';
import CompletedOrderHeatmapChart from './Heatmap/CompletedOrderHeatmapChart';
import { makeSelectProperty } from './selectors';

const CompletedVsCancelledOrderChart = ({
  selectedTimePeriod,
  isTimePeriodFilterStatusChanged,
}) => {
  // const isHourly = selectedTimePeriod.slug === HOURLY_TIME_PERIOD; // remove heatmap
  const isHourly = false;

  const COMPARISON_TABS = [
    {
      id: 1,
      title: 'Completed Orders',
      tabContent: null,
    },
    {
      id: 2,
      title: 'Cancelled Orders',
      tabContent: null,
    },
  ];
  let tabContentOne;
  if (!isTimePeriodFilterStatusChanged) {
    tabContentOne = isHourly ? (
      <CompletedOrderHeatmapChart />
    ) : (
      <CompletedOrderBarChart />
    );
  } else {
    tabContentOne = COMPARISON_TABS[0].tabContent;
  }
  COMPARISON_TABS[0].tabContent = tabContentOne;

  let tabContentTwo;
  if (!isTimePeriodFilterStatusChanged) {
    tabContentTwo = isHourly ? (
      <CancelledOrderHeatmapChart />
    ) : (
      <CancelledOrderBarChart />
    );
  } else {
    tabContentTwo = COMPARISON_TABS[1].tabContent;
  }
  COMPARISON_TABS[1].tabContent = tabContentTwo;
  const [selectedTab, setSelectedTab] = useState(COMPARISON_TABS[0].id);

  const handleChangeTab = id => {
    setSelectedTab(id);
  };

  const tabContentEl = (() => {
    const tabContentIndex = COMPARISON_TABS.findIndex(
      ct => ct.id === selectedTab,
    );
    return COMPARISON_TABS[tabContentIndex].tabContent;
  })();

  return (
    <SectionCard
      title="Completed vs Cancelled Orders"
      metricKey="completedOrders"
      className="h-full"
    >
      <div className="mb-4">
        <ChartTabs
          tabs={COMPARISON_TABS}
          selected={selectedTab}
          onSelect={handleChangeTab}
        />
      </div>
      {tabContentEl}
    </SectionCard>
  );
};

CompletedVsCancelledOrderChart.propTypes = {
  selectedTimePeriod: PropTypes.any,
  isTimePeriodFilterStatusChanged: PropTypes.bool,
};

const mapStateToProps = createStructuredSelector({
  selectedTimePeriod: makeSelectProperty('selectedTimePeriod'),
  isTimePeriodFilterStatusChanged: makeSelectProperty(
    'isTimePeriodFilterStatusChanged',
  ),
});

const withConnect = connect(mapStateToProps, null);

export default withConnect(CompletedVsCancelledOrderChart);
